<template>
  <div id="csContainer">
    <el-button type="primary"  size="small" class="marker" @click="drawMarker()">添加标注</el-button>
    <div id="msg1" :style="{left:scenePos.x+30+this.left+'px',top:scenePos.y+this.top+'px'}" v-show="isShow">
      <el-input  type="text"  placeholder="标记名称" @keyup.enter="update" v-model="msg"  >
      </el-input>
    </div>

    <div id='submit1' :style="{left:scenePos.x+180+this.left+'px',top:scenePos.y+this.top+'px'}" v-show="isShow">
      <el-button   type="primary"   @click="update"  >ok</el-button>
    </div>

  </div>
</template>

<script>
/* eslint-disable */
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"

export default {
  name: "drawMarker",
  data () {
    return {
      viewer: null,

      isDrawing:true,
      curLat:0,
      curLon:0,
      curText:'',
      handler: null,
      scenePos:'',
      billboards:'',
      labels:'',

      isShow:false,
      tipShow:true,
      msg:'',
      curIndex:null,
      left: null,
      top:null
    }
  },
  directives:{
    focus(el){
      el.focus()
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init(){
      let vm = util.getViewer("csContainer");
      this.viewer = vm;
    },
    drawMarker(){
      let viewer= this.viewer;
      viewer.scene.globe.depthTestAgainstTerrain = false;
      this.top = document.getElementById("csContainer").getBoundingClientRect().top;
      this.left = document.getElementById("csContainer").getBoundingClientRect().left;
      const _this = this;
      _this.handler = new Cesium.ScreenSpaceEventHandler(viewer.canvas);
      _this.handler.setInputAction(evt =>{
        // evt.position.x=evt.position.x-left;
        // evt.position.y=evt.position.y-top;
        var earthPostion = viewer.scene.pickPosition(evt.position);
        if (Cesium.defined(earthPostion)){
          _this.scenePos = evt.position;

          _this.add(viewer)
        }
      },Cesium.ScreenSpaceEventType.LEFT_CLICK);
      // 将billboard和label存放在数组中
      _this.billboards = viewer.scene.primitives.add(new Cesium.BillboardCollection())
      _this.labels = viewer.scene.primitives.add(new Cesium.LabelCollection())
    },
    add(viewer){
      const _this = this;
      _this.isShow = true;
      _this.tipShow = false;
      _this.billboards.add({
        id:'marker%d' % _this.billboards.length,
        position: viewer.scene.globe.pick(viewer.camera.getPickRay(_this.scenePos),viewer.scene),
        image:'img/marker.png'
      });
      _this.labels.add({
        position: viewer.scene.globe.pick(viewer.camera.getPickRay(_this.scenePos),viewer.scene),
        id: 'marker%d' % _this.billboards.length,
        text:'',
        font: '24px sans-serif',
        fillColor: Cesium.Color.BLACK,
        outlineWidth: 5,
        outlineColor: Cesium.Color.WHITE,
        pixelOffset: new Cesium.Cartesian2(20, 20),
        style: Cesium.LabelStyle.FILL_AND_OUTLINE
      });
      _this.handler.destroy();
    },
    update:function () {
      if(this.curIndex==undefined){
        this.curIndex=this.labels.length-1
      }

      this.labels.get(this.curIndex).text=this.msg;
      this.isShow=false;
      this.msg='';
      this.curIndex=undefined;
    }
  },
}



</script>

<style scoped>
  .marker{
    position: absolute;
    margin-left: 25px;
    margin-top:7px;
    z-index: 999;
  }
  #msg1, .msg {
    width: 150px;
    height: 30px;
    position: fixed;
    z-index: 110;
  }

  #submit1, .submit {
    position: fixed;
    height: 34px;
    width: 34px;
    z-index: 110;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
